import { getClientCode, updateState, setNicks, setIsOwner } from '../../state-manager.js';
import { startSetupContinuation, loadApp } from '../../shared/ui-flow.js';
import { showRegistrationForm } from './ui-registration.js';
import { login } from './auth.js';
import { loadClientProfiles } from '../../requests/profiles.js';
import { loadClient, loadClientNicks } from '../../requests/clients.js';

let isRegisterBound = false;
let isLoginBound = false;

export function bindRegisterButton() {
  if (isRegisterBound) return;
  isRegisterBound = true;

  const registerBtn = document.getElementById('register-btn');
  if (registerBtn) {
    registerBtn.addEventListener('click', () => {
      document.getElementById('login-container')?.classList.add('hidden');
      document.getElementById('registration-container')?.classList.remove('hidden');
      showRegistrationForm();
    });
  }
}

export function showLoginForm({ showRegister = false } = {}) {
  console.log("Showing login form");
  const loginForm = document.getElementById('login-container');
  const registerBtn = document.getElementById('register-btn');

  loginForm?.classList.remove('hidden');
  document.getElementById('registration-container')?.classList.add('hidden');

  if (registerBtn) {
    registerBtn.classList.toggle('hidden', !showRegister);
  }

  // Auto-fill client code field
  const codeInput = document.getElementById('client_code');
  const clientCode = getClientCode();
  if (codeInput && typeof getClientCode() === 'string') {
    codeInput.value = getClientCode();
  }
      
  const nickInput = document.getElementById('nick');
  if (nickInput) {
    // Delay focus to allow for form rendering if needed
    setTimeout(() => {
      nickInput.focus();
    }, 100);
  } 
  
  bindLoginButton();
  bindRegisterButton();
}

export function bindLoginButton() {
  if (isLoginBound) return;
  isLoginBound = true;

  const loginBtn = document.getElementById('login-btn');
  if (!loginBtn) return;

  loginBtn.addEventListener('click', async () => {
    const code = document.getElementById('client_code')?.value.trim();
    const nick = document.getElementById('nick')?.value.trim();

    if (!code || !nick) {
      alert('Please fill in both Code and Nickname.');
      return;
    }

    const result = await login(nick, code);
    if (result.success && result.token) {
      updateState({
        accessToken: result.token,
        isLoggedIn: true,
        nick
      });
      console.log("[bindLoginButton] Login successful:", result);

      // Load client
      const client = await loadClient();
      if (client) {
        updateState({
          clientCode: client.code,
          clientId: client.id,
          clientType: client.client_type,
        });
      }

      // LOad client nicks
      const nicks = await loadClientNicks();
      console.log("[bindLoginButton] Loaded client nicks:", nicks);
      if (nicks) {
        // const owner = nicks.nicks.filter(n => n.nick && n.is_owner);
        const owner = nicks.find(n => n.nick && n.is_owner);
        setIsOwner(nick === owner.nick);
        setNicks(nicks);
        // const nicks = nicks.nicks.filter(n => n.nick && !n.is_owner);
        // const nicknames = nicks.nicks.map(n => n.nick);
        // setNicks(nicknames);
      }
      
        // Load client profiles after successful login
      const profiles = await loadClientProfiles();
      
      if (profiles.length > 0) {
        updateState({ profiles });
        loadApp(); // they're already set up
      } else {
        startSetupContinuation(); // move to profile creation
      }      
    } else {
      alert('Login failed. Please check your credentials and try again.');
    }
  });
}

  